import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { StoreService } from '../shared/store.service';
import { ReceiptSubmissionRequested } from './request-a-receipt.actions';
import * as RequestAReceiptSelectors from './request-a-receipt.selectors';
import { RequestReceiptPayload } from './types';

@Injectable({ providedIn: 'root' })
export class RequestAReceiptFacade {
  requestAReceiptPayload: Observable<RequestReceiptPayload> =
    this.storeService.getState(RequestAReceiptSelectors.requestReceiptPayload);

  requestReceiptFormIsSubmitted: Observable<boolean> =
    this.storeService.getState(
      RequestAReceiptSelectors.requestReceiptFormIsSubmitted,
    );

  requestReceiptSubmissionSucceeded: Observable<boolean> =
    this.storeService.getState(
      RequestAReceiptSelectors.requestReceiptSubmissionSucceeded,
    );
  requestReceiptSubmissionFailed: Observable<boolean> =
    this.storeService.getState(
      RequestAReceiptSelectors.requestReceiptSubmissionFailed,
    );

  constructor(private storeService: StoreService) {}

  requestAReceiptSubmission(response: RequestReceiptPayload) {
    this.storeService.dispatchAction(new ReceiptSubmissionRequested(response));
  }
}
